import React, { useState, useRef, useEffect, useContext } from "react";
import Calendar from "../../../images/calendar2.svg";
import "../../../stylesheet/forms.css";
import { RiCloseLine } from "react-icons/ri";
import { addNotes, editNotes } from "../../../Utils/localStore";
import ToastContext from "../../../context/toasterContex";

const NewNote = ({ onClose, update, details, edit }) => {
  const { toast } = useContext(ToastContext)
  const [noteData, setNoteData] = useState({
    userLocalId: details.localID
  })
  const notesForm = useRef(null)
  let today = Date.now()
  const formatter = new Intl.DateTimeFormat('en-NG', {
    dateStyle: 'full',
    timeStyle: 'long',
  })
  today = formatter.format(today);
  const handleFormUpdate = (e) => {
    const { id, value } = e.target
    setNoteData({
      ...noteData,
      date: today,
      [id]: value
    })
  }
  const handleFormSubmit = async (e) => {
    e.preventDefault()

    if (!edit) {
      let today = Date.now()
      const formatter = new Intl.DateTimeFormat([], { year: 'numeric', month: '2-digit', day: '2-digit' });
      today = formatter.format(today);

      const newNote = { noteData, date: today }
      await addNotes(noteData)
        .then(resp => {
          update()
          toast.success('Note Added successfully', { position: toast.POSITION.TOP_CENTER })
        })
        .catch(err => {
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    } else {
      await editNotes(noteData)
        .then(resp => {
          update()
          toast.success('Note updated successfully', { position: toast.POSITION.TOP_CENTER })
        })
        .catch(err => {
          console.log({ err });
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    }
    onClose(e)
  }
  useEffect(() => {
    if (notesForm.current) {
      const r = document.querySelector('#new_note')
      r.scrollTop = 0
    }
    if (edit) {
      setNoteData(details)
    }
  }, []);
  return (
    <>
      <dialog >
        <div className="w-full lg:w-[700px] bg-white rounded-md border relative">
          <section className="font-euclid-circular-a w-full relative">
            <div className="w-full bg-primary rounded-t-md" >
              <div className="flex justify-between w-full align-middle">
                <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                  {
                    !edit ? 'Add Note' : 'Edit Note'
                  }

                </h2>
                <div className="leading-7 text-xl font-semibold  p-8">
                  <button onClick={onClose}> <RiCloseLine color="white" size={30} /> </button>
                </div>
              </div>
            </div>
            <form ref={notesForm} id="new_note" onSubmit={(e) => handleFormSubmit(e)}
              className="p-4 lg:p-8 justify-center gap-8 h-[700px] overflow-hidden overflow-y-auto">
              <div className="ml-4 mt-2  items-center note_title w-full">
                <div className="flex gap-10 align-middle">
                  <div className="w-3.5 h-3.5 bg-sky-500 rounded-[5px]" />

                  <label htmlFor="title">Note Title</label>
                </div>
                <p className="my-4 ml-12">
                  <input className="w-full text-gray-400" type="text" id="title" name="title" placeholder="Enter note title"
                    defaultValue={noteData.title || ''}
                    onChange={(e) => handleFormUpdate(e)} />
                </p>
              </div>

              <div className="ml-[9px] flex gap-10 items-center">
                <img src={Calendar} alt="calendar icon" />
                <span> {today}</span>
              </div>

              <div className="my-6">
                <label className="my-5" htmlFor="compliants">Compliants</label>
                <textarea
                  placeholder="Chief complainants"
                  id="compliants"
                  name="compliants"
                  onChange={(e) => handleFormUpdate(e)}
                  defaultValue={noteData.compliants || ''}
                  className="w-full lg:w-[582px] h-[154px] border border-neutral-600 my-3"
                />
              </div>

              <div className="my-6">
                <label className="my-5" htmlFor="findings">Findings</label>
                <textarea
                  placeholder="On Investigation"
                  id="findings"
                  name="findings"
                  onChange={(e) => handleFormUpdate(e)}
                  defaultValue={noteData.findings || ''}
                  className="w-full lg:w-[582px] h-[154px] border border-neutral-600 my-3"
                />
              </div>

              <div className="my-6">
                <label className="my-5" htmlFor="diagnosis">Diagnosis</label>
                <textarea
                  placeholder="Diagnosis"
                  id="diagnosis"
                  name="diagnosis"
                  defaultValue={noteData.diagnosis || ''}
                  onChange={(e) => handleFormUpdate(e)}
                  className="w-full lg:w-[582px] h-[154px] border border-neutral-600 my-3"
                />

              </div>


              <div className="my-6">
                <label className="my-5" htmlFor="procedure">Treatment procedure</label>
                <textarea
                  placeholder="Treatment procedure"
                  id="procedure"
                  name="procedure"
                  defaultValue={noteData.procedure || ''}
                  onChange={(e) => handleFormUpdate(e)}
                  className="w-full lg:w-[582px] h-[154px] border border-neutral-600 my-3"
                />
              </div>
              <div className="flex justify-between gap-10 py-2">
                <button type="submit"
                  className="rounded-md text-white bg-primary p-2 w-full">

                  {
                    !edit ? 'Submit' : 'Update'
                  }
                </button>
                <button autoFocus className="p-2 border border-red-400 rounded-md w-full" onClick={(e) => {
                  e.preventDefault(); onClose(e)
                }}>
                  Cancel
                </button>
              </div>
            </form>
          </section>
        </div>
      </dialog>

    </>
  );
};

export default NewNote;
